import { render, staticRenderFns } from "./UserAddForm.vue?vue&type=template&id=0566f079&scoped=true&"
import script from "./UserAddForm.vue?vue&type=script&lang=js&"
export * from "./UserAddForm.vue?vue&type=script&lang=js&"
import style0 from "./UserAddForm.vue?vue&type=style&index=0&id=0566f079&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0566f079",
  null
  
)

export default component.exports